import React, { Component } from "react";
import { Redirect, BrowserRouter as Router, Route, Switch } from "react-router-dom";

//Dashboard
import Dashboard from "./components/views/admin/Dashboard";
import DashboardCardExpanded from "./components/views/admin/DashboardCardExpanded";
import DashboardCardViews from "./components/views/admin/DashboardCardViews";
import ProductStep from './components/forms/partials/ProductStep';
import Product from './components/forms/partials/Product';

//Layout principales
import Main from './components/layouts/Main';
import MainAdmin from './components/layouts/MainAdmin';
import MainLogin from './components/layouts/MainLogin';

//Login
import Login from './components/views/login/Login';
import Forgot from './components/views/login/Forgot';
import Reset from './components/views/login/Reset';
import Validation from "./components/views/login/Validation";

class Routing extends Component {
    render() {
        return (
            <Router>
                <Switch>
                    <Route path='/' component={Main} exact />
                    <Route path='/dashboard'>
                        {(window.localStorage.getItem('headersSetCookie') !== undefined) ? (
                            <MainAdmin>
                                <Switch>
                                    <Route path='/dashboard' exact component={Dashboard} />
                                    <Route path='/dashboard/:card' exact component={DashboardCardExpanded} />
                                    <Route path='/dashboard/:card/:views/:id' exact component={DashboardCardViews} />
                                    <Route path='/dashboard/:card/:views' exact component={DashboardCardViews} />
                                    <Route path='/dashboard/promociones/:id/producto/create'  exact component={ProductStep} />
                                    <Route path='/dashboard/promociones/:id/pp/:idPromotionProduct/p/:idProduct/o/:view/:idPromotionProductOffices'  exact component={Product} />
                                </Switch>
                            </MainAdmin>
                        ) : (
                            <Redirect to={"/login"} />
                        )}
                    </Route>

                    <MainLogin>
                        <Switch>
                            <Route path='/login' component={Login} exact />
                            <Route path='/recovery' component={Forgot} exact />
                            <Route path='/validation' component={Validation} exact />
                            <Route path='/change-password/:hash' component={Reset} exact />
                        </Switch>
                    </MainLogin>
                </Switch>
            </Router>
        );
    }
}

export default Routing;
